import type { TFiscalReportListItem, TFiscalVatListInfoFilterItem } from './types';

// Stable references for selectors: a new `[]` on every call makes `useSelector` rerender needlessly.
export const EMPTY_FISCAL_REPORT_LIST: TFiscalReportListItem[] = [];
export const EMPTY_FISCAL_VAT_LIST_INFO_FILTER: TFiscalVatListInfoFilterItem[] = [];

export const FISCAL_REPORTS_ACTIONS = {
	GET_FISCAL_VAT_LIST_INFO_FILTER_REQUEST: 'GET_FISCAL_VAT_LIST_INFO_FILTER_REQUEST',
	GET_FISCAL_VAT_LIST_INFO_FILTER_SUCCESS: 'GET_FISCAL_VAT_LIST_INFO_FILTER_SUCCESS',
	GET_FISCAL_VAT_LIST_INFO_FILTER_FAILURE: 'GET_FISCAL_VAT_LIST_INFO_FILTER_FAILURE',
	GET_FISCAL_REPORT_LIST_REQUEST: 'GET_FISCAL_REPORT_LIST_REQUEST',
	GET_FISCAL_REPORT_LIST_SUCCESS: 'GET_FISCAL_REPORT_LIST_SUCCESS',
	GET_FISCAL_REPORT_LIST_FAILURE: 'GET_FISCAL_REPORT_LIST_FAILURE',
	DOWNLOAD_FISCAL_PDF_REQUEST: 'DOWNLOAD_FISCAL_PDF_REQUEST',
	DOWNLOAD_FISCAL_PDF_SUCCESS: 'DOWNLOAD_FISCAL_PDF_SUCCESS',
	DOWNLOAD_FISCAL_PDF_FAILURE: 'DOWNLOAD_FISCAL_PDF_FAILURE',
	DOWNLOAD_FISCAL_CSV_REQUEST: 'DOWNLOAD_FISCAL_CSV_REQUEST',
	DOWNLOAD_FISCAL_CSV_SUCCESS: 'DOWNLOAD_FISCAL_CSV_SUCCESS',
	DOWNLOAD_FISCAL_CSV_FAILURE: 'DOWNLOAD_FISCAL_CSV_FAILURE',
	DOWNLOAD_FISCAL_XLSX_REQUEST: 'DOWNLOAD_FISCAL_XLSX_REQUEST',
	DOWNLOAD_FISCAL_XLSX_SUCCESS: 'DOWNLOAD_FISCAL_XLSX_SUCCESS',
	DOWNLOAD_FISCAL_XLSX_FAILURE: 'DOWNLOAD_FISCAL_XLSX_FAILURE',
} as const;

export enum EReportStatus {
	PENDING = 'pending',
	SUBMITTED = 'submitted',
}

export enum EReportType {
	NON_UNION = 'non_union',
	UNION = 'union',
	IOSS = 'ioss',
	NON_EU_IOSS = 'non_eu_ioss',
}

export enum EReportTypeDownload {
	NON_UNION = 'non_union',
	UNION = 'union',
	IOSS = 'import',
	NON_EU_IOSS = 'non_eu_gb',
}

export enum EReportMtaStatus {
	PENDING = 'pending',
	CANCELED = 'canceled',
	SENT = 'sent',
	QUEUED = 'queued',
	SUBMITTED = 'submitted',
	ERROR = 'error',
	UNFINISHED_WITH_WARNINGS = 'unfinished_with_warnings',
	UNFINISHED = 'unfinished',
}

export enum EReportInvoicePaymentStatus {
	PAID = 'paid',
	PENDING = 'pending',
	PARTIALLY_PAID = 'partially_paid',
	OVERDUE = 'overdue',
	NO_INVOICE_FOUND = 'no_invoice_found',
}

export const getReportTypeDownload = (reportType: EReportType) => {
	return reportType === EReportType.IOSS
		? EReportTypeDownload.IOSS
		: reportType === EReportType.NON_EU_IOSS
			? EReportTypeDownload.NON_EU_IOSS
			: reportType === EReportType.NON_UNION
				? EReportTypeDownload.NON_UNION
				: EReportTypeDownload.UNION;
};

export enum EPaymentHandlingMode {
	DIRECT = 'direct',
	INDIRECT = 'indirect',
}

export const PAYMENT_HANDLING_MODE = {
	[EPaymentHandlingMode.DIRECT]: 'Direct',
	[EPaymentHandlingMode.INDIRECT]: 'Indirect',
};
